/**
 * providerPortal - Cliente e chamada única do Portal do Prestador.
 *
 * Sessão do prestador fica em armazenamento PRÓPRIO (não mistura com o login
 * do sistema). Toda leitura/ação passa pela Edge Function `provider-portal`.
 *
 * RELEASE: 2026-10-12 v1.0.0 - Versão inicial (Fase 1).
 */
import { createClient } from '@supabase/supabase-js';

export const providerPortalClient = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  { auth: { storageKey: 'uaizy-provider-portal', persistSession: true, autoRefreshToken: true, detectSessionInUrl: false } },
);

/** Executa uma ação da lista fechada da Edge Function. */
export async function callProviderPortal<T>(tenantSlug: string, action: string, payload: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await providerPortalClient.functions.invoke('provider-portal', {
    body: { action, tenant_slug: tenantSlug, payload },
  });
  if (error) {
    // Mensagem amigável devolvida pela função
    let msg = 'Não foi possível concluir';
    try { msg = (await (error as { context?: Response }).context?.json())?.error ?? msg; } catch { /* sem corpo */ }
    throw new Error(msg);
  }
  return data as T;
}
